export const membershipPagesRouterMatches = () => ({
    myTripsReactivation: /^\/?(?:travel\/membership-pages\/)?membership_mytrips_reactivation\/(.*)/,
    membership_retention: /^\/?(?:travel\/membership-pages\/)?membership_retention\/(.*)/,
    membership_cancellation: /^\/?(?:travel\/membership-pages\/)?membership_cancellation\/(.*)/,
    membership_cancellation_request: /^\/?(?:travel\/membership-pages\/)?membership_cancellation_request\/(.*)/,
});

export const membershipPagesAppChangePages = () => ({
    secure: {
        membership_mytrips_reactivation: 'membershippages',
        membership_retention: 'membershippages',
        membership_cancellation: 'membershippages',
        membership_cancellation_request: 'membershippages',
    },
    membershippages: {
        membership_mytrips_reactivation: 'myTripsReactivation',
        membership_retention: 'membership_retention',
        membership_cancellation: 'membership_cancellation',
        membership_cancellation_request: 'membership_cancellation_request',
    },
});

export const membershipPagesSecurePages = () => ({
    membership_mytrips_reactivation: 'membershippages',
    membership_retention: 'membershippages',
    membership_cancellation: 'membershippages',
    membership_cancellation_request: 'membershippages',
});
